export const externalFontFiles = (baseUrl) => ({
    /*
    This font isn't actually used, but there to support the old theme.
    Therefor, it just points to an existing font file so it won't break
    */
    // TheSans-C4s - Regular
    TheSansC4sRegularWoff: `${baseUrl}ANWB-TheSans_7_.woff2`,
    TheSansC4sRegularWoff2: `${baseUrl}ANWB-TheSans_7_.woff2`,
    // TheSans-C4s - SemiBold
    TheSansC4sSemiBoldWoff: `${baseUrl}ANWB-TheSans_7_.woff2`,
    TheSansC4sSemiBoldWoff2: `${baseUrl}ANWB-TheSans_7_.woff2`,
    // TheSans-C4s - SemiBold Italic
    TheSansC4sSemiBoldItalicWoff: `${baseUrl}ANWB-TheSans_6i.woff2`,
    TheSansC4sSemiBoldItalicWoff2: `${baseUrl}ANWB-TheSans_6i.woff2`,
    // TheSans-C4s - Medium
    TheSansC4sMediumWoff: `${baseUrl}ANWB-TheSans_7_.woff2`,
    TheSansC4sMediumWoff2: `${baseUrl}ANWB-TheSans_7_.woff2`,
    // TheSans-C4s - Bold
    TheSansC4sBoldWoff: `${baseUrl}ANWB-TheSans_7_.woff`,
    TheSansC4sBoldWoff2: `${baseUrl}ANWB-TheSans_7_.woff2`,
    // TheSans-C4s - Bold Italic
    TheSansC4sBoldItalicWoff: `${baseUrl}ANWB-TheSans_7i.woff`,
    TheSansC4sBoldItalicWoff2: `${baseUrl}ANWB-TheSans_7i.woff2`,
    // ClanOT - Regular
    ClanOTRegularWoff: `${baseUrl}ANWB-ClanOT_5.woff`,
    ClanOTRegularWoff2: `${baseUrl}ANWB-ClanOT_5.woff2`,
    // ClanOT - News
    ClanOTNewsWoff: `${baseUrl}ANWB-ClanOT_5news.woff`,
    ClanOTNewsWoff2: `${baseUrl}ANWB-ClanOT_5news.woff2`,
    // ClanOT - Medium
    ClanOTMediumWoff: `${baseUrl}ANWB-ClanOT_6.woff`,
    ClanOTMediumWoff2: `${baseUrl}ANWB-ClanOT_6.woff2`,
    // ClanOT - Bold
    ClanOTBoldWoff: `${baseUrl}ANWB-ClanOT_7.woff`,
    ClanOTBoldWoff2: `${baseUrl}ANWB-ClanOT_7.woff2`,
    // ClanOT - Narrow Bold
    ClanOTNarrowBoldWoff: `${baseUrl}ANWB-ClanOT_7n.woff`,
    ClanOTNarrowBoldWoff2: `${baseUrl}ANWB-ClanOT_7n.woff2`,
    // BerninaSans - Regular
    BerninaSansRegularWoff: `${baseUrl}ANWB-BerninaSans_5.woff`,
    BerninaSansRegularWoff2: `${baseUrl}ANWB-BerninaSans_5.woff2`,
    // BerninaSans - Regular Italic
    BerninaSansRegularItalicWoff: `${baseUrl}ANWB-BerninaSans_5i.woff`,
    BerninaSansRegularItalicWoff2: `${baseUrl}ANWB-BerninaSans_5i.woff2`,
    // BerninaSans - Semibold
    BerninaSansSemiboldWoff: `${baseUrl}ANWB-BerninaSans_6.woff`,
    BerninaSansSemiboldWoff2: `${baseUrl}ANWB-BerninaSans_6.woff2`,
    // BerninaSans - SemiBold
    BerninaSansSemiBoldWoff: `${baseUrl}ANWB-BerninaSans_6.woff`,
    BerninaSansSemiBoldWoff2: `${baseUrl}ANWB-BerninaSans_6.woff2`,
    // Verveine - Regular
    VerveineRegularWoff: `${baseUrl}ANWB-Verveine_5.woff`,
    VerveineRegularWoff2: `${baseUrl}ANWB-Verveine_5.woff2`,
});
//# sourceMappingURL=externalFontFiles.js.map